import React from "react";
import Router from "next/router";
import Link from "next/link";
import { composeDataMethods } from "@lululemon/mwa-utils";
import useCustomRouter from "./hooks/use-custom-router";

function getDisplayName(c) {
  return c.displayName || c.name || "Component";
}

function withRouter(Component) {
  const WrappedComponent = (props) => {
    const routerProps = useCustomRouter();

    return <Component {...props} {...routerProps} />;
  };

  WrappedComponent.displayName = `withRouter(${getDisplayName(Component)})`;

  return composeDataMethods(Component)(WrappedComponent);
}

export { Router, Link };
export default withRouter;
